/**
 * @author TomaszCzura ({}
 */

import axios from 'axios';
import store from '../store';
import * as actions from '../actions/users-actions';
import * as siteActions from '../actions/sites-actions';
import * as endpoints from './endpoints';
import {toUserObject} from '../model/user';
import {getCurrentUserId, logout} from '../utils/auth';
import * as blockUtils from '../utils/BlockUtils';

export function registerNewUser(user) {
  const data = toUserObject(user);
  return axios.post(endpoints.USERS, data, endpoints.headers())
      .then((response) => {
        store.dispatch(actions.createUserSuccess(user));
        return response;
      })
      .catch(function(error) {
        const userError = actions.createUserError(error);
        store.dispatch(userError);
        return userError;
      });
}

export function getAvailableSiteForUser() {
  return axios.get(`${endpoints.USERS}/sites`, endpoints.headers());
}

export function getUsers(data) {
  return axios.get(endpoints.USERS, endpoints.headers(data))
      .then((response) => {
        const users = response.data.content.map((user) => toUserObject(user));
        const totalPages = response.data.totalPages;
        const totalElements = response.data.totalElements;
        store.dispatch(actions.getUsersSuccess(users, totalPages, totalElements));
        blockUtils.unblockUI();
        return response;
      })
      .catch((error) => {
        endpoints.handleUnauthorizedError(error, () => {
          store.dispatch(actions.getUsersError(error));
          blockUtils.unblockUI();
        });
      },
      );
}

export function getUser(userId) {
  const user = store.getState().usersState.users.filter((user) => user.id === userId)[0];
  if (user) {
    return store.dispatch(actions.getUserSuccess(user));
  } else {
    return axios.get(`${endpoints.USERS}/${userId}`, endpoints.headers())
        .then((response) => {
          const user = toUserObject(response.data);
          store.dispatch(actions.getUserSuccess(user));
          return response;
        })
        .catch(function(error) {
          store.dispatch(actions.getUserError(error));
        });
  }
}

export function getUserProfile() {
  const profile = store.getState().usersState.userProfile;
  const currentUserId = parseInt(getCurrentUserId());
  if (profile && profile.id === currentUserId) {
    const profileCopy = Object.assign({}, profile);
    return store.dispatch(actions.getProfileSuccess(profileCopy));
  } else {
    return refreshUserProfile(currentUserId);
  }
}

export function refreshUserProfile(currentUserId) {
  return axios.get(`${endpoints.USERS}/${currentUserId}`, endpoints.headers())
      .then((response) => {
        const profile = toUserObject(response.data);

        const sites = profile.sites.filter((site) => site.selectedByUser === true);

        store.dispatch(actions.getProfileSuccess(profile));
        store.dispatch(siteActions.getSitesSuccess(sites));
        store.dispatch(actions.changeLanguage(profile.language));
        return response;
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 404) {
          logout(() => {
            const loginUrl = window.location.protocol + '//' + window.location.host + '/login';
            window.location.replace(loginUrl);
          });
        } else {
          store.dispatch(actions.getProfileError(error));
        }
      });
}

export function updateUser(user) {
  const data = toUserObject(user);

  return axios.put(`${endpoints.USERS}/${user.id}`, data, endpoints.headers())
      .then((response) => {
        store.dispatch(actions.updateUserSuccess(user));
        return response;
      })
      .catch(function(error) {
        store.dispatch(actions.updateUserError(user, error));
      });
}

export function updateOwnUser(user) {
  const data = toUserObject(user);

  return axios.put(`${endpoints.USERS}/${user.id}`, data, endpoints.headers())
      .then((response) => {
        store.dispatch(actions.changeLanguage(user.language));
        store.dispatch(actions.updateUserSuccess(user));
        return response;
      })
      .catch(function(error) {
        store.dispatch(actions.updateUserError(user, error));
      });
}

export function deleteUser(user) {
  return axios.delete(`${endpoints.USERS}/${user.id}`, endpoints.headers())
      .then((response) => {
        store.dispatch(actions.deleteUserSuccess(user));
        return response;
      })
      .catch(function(error) {
        store.dispatch(actions.deleteUserError(user, error));
      });
}

export function addAllSitesToUser(userId) {
  return axios.put(`${endpoints.USERS}/${userId}/sites/all`, {}, endpoints.headers());
}

export function updateUserPassword(user, data) {
  return axios.put(`${endpoints.USERS}/${user.id}/password`, data, endpoints.headers());
}
